import _t from 'i18n!nls/my-purchases-graphql';

export type TabNames = {
  subscriptions: string;
  transactions: string;
  'financial-aid': string;
};

export const getTabNames = (): TabNames => {
  return {
    subscriptions: _t('Subscriptions'),
    transactions: _t('Payment History'),
    'financial-aid': _t('Financial Aid'),
  };
};

export const fetchTabnameByLocation = (pathname: string) => {
  const tabNames = getTabNames();
  const tabNameKeys = tabNames && Object.keys(tabNames);

  switch (pathname) {
    case '/my-purchases/subscriptions':
      return 'subscriptions';
    case '/my-purchases/transactions':
      return 'transactions';
    case '/my-purchases/financial-aid':
      return 'financial-aid';
    default:
      return tabNameKeys?.[0] ?? undefined;
  }
};

export const fetchTrackingTabNameByLocation = (pathname: string) => {
  const tabNames = getTabNames();
  const tabNameKeys = tabNames && Object.keys(tabNames);

  switch (pathname) {
    case '/my-purchases/subscriptions':
      return 'subscriptions';
    case '/my-purchases/transactions':
      return 'transactions';
    case '/my-purchases/financial-aid':
      return 'financial_aid';
    default:
      return tabNameKeys?.[0] ?? undefined;
  }
};
